/**
 * Zeitschritte API - Operacije za vremenske korake
 */

import { httpClient } from '../client/httpClient';
import { ZeitschritteData, ZeitschritteResponse } from '../types/apiTypes';
import { logError } from '../utils/errorHandler';

export const zeitschritteApi = {
  /**
   * Dohvati vremenske korake za određenu sesiju
   */
  getZeitschritte: async (sessionId: string): Promise<ZeitschritteResponse | null> => {
    try {
      const response = await httpClient.get<ZeitschritteResponse>(
        `/api/training/get-zeitschritte/${sessionId}`
      );

      if (!response.success) {
        // Return null for 404 errors (no data)
        return null;
      }

      return response.data || null;
    } catch (error) {
      logError('zeitschritteApi.getZeitschritte', error);
      throw error;
    }
  },

  /**
   * Ažuriraj vremenske korake za određenu sesiju
   */
  updateZeitschritte: async (
    sessionId: string,
    zeitschritteData: ZeitschritteData
  ): Promise<ZeitschritteResponse> => {
    try {
      const response = await httpClient.post<ZeitschritteResponse>(
        '/api/training/save-zeitschritte',
        {
          sessionId,
          zeitschritte: zeitschritteData,
        }
      );

      if (!response.success) {
        throw new Error(response.error || 'Failed to save zeitschritte');
      }

      return response.data!;
    } catch (error) {
      logError('zeitschritteApi.updateZeitschritte', error);
      throw error;
    }
  },

  /**
   * Legacy support - kreiraj vremenske korake
   */
  createZeitschritte: async (
    sessionId: string,
    zeitschritteData: Record<string, unknown>
  ): Promise<ZeitschritteResponse> => {
    return zeitschritteApi.updateZeitschritte(
      sessionId,
      zeitschritteData as unknown as ZeitschritteData
    );
  },
};
